<template>
  <CContainer>
    <CCard class="mt-3">
      <CCardHeader>
        <CCardTitle>
          {{ title }}
        </CCardTitle>
        <CCardSubtitle>
          <small>
            Descripcion de la pantalla.
          </small>
        </CCardSubtitle>
      </CCardHeader>
      <CCardBody>
        <VerticalDynamicForm :fields="tracking_fields" />
      </CCardBody>
      <CCardFooter>
        <div class="d-flex justify-content-center">
          <CButton
            color="success"
            :class="isValidForm ? '' : 'disabled'"
            :disabled="!isValidForm"
            @click="(event) => saveTracking(event)">
            <CIcon name="cil-check-circle"></CIcon>
            <span class="align-middle ml-2">Grabar</span>
            <CSpinner 
              size="sm" 
              class="align-middle mx-2" 
              v-show="loading" />
          </CButton>
          <CButton 
            color="danger"
            variant="outline"
            class="ml-2"
            @click="() => close()">
            <CIcon name="cil-x-circle"></CIcon>
            <span class="align-middle ml-2">Cancelar</span>
          </CButton>
        </div>
      </CCardFooter>
    </CCard>
  </CContainer>
</template>

<script>
  import moment from "moment";

  import VerticalDynamicForm from "@/components/containers/VerticalDynamicForm.vue";

  import { 
    dataListClasesSeguimientos, 
    guardarSeguimiento 
  } from "@/api";


  export default {
    name: "FormTracking",
    components: {
      VerticalDynamicForm,
    },
    props: {
      title: String,
      employeeId: String,
      opportunityId: String,
      orderId: String,
      documentId: String,
      directoryId: String,
      dependencyId: String
    },
    data() {
      return {
        loading: false,
        tracking_fields: [
          {
            key: "clase_Seguimiento",
            label: "Clase Seguimiento:",
            value: "",
            type: "select",
            options: [],
            required: true,
            prepend_content: {
              name: 'bookmark-check'
            }
          },
          {
            key: "fecha",
            label: "Fecha Seguimiento: ",
            value: "",
            type: "date",
            required: true,
            prepend_content: {
              name: "calendar-date"
            }
          },
          {
            key: "hora",
            label: "Hora Seguimiento: ",
            value: "",
            type: "time",
            required: true,
            prepend_content: {
              name: "clock"
            }
          },
          {
            key: "comentarios",
            label: "Comentarios: ",
            value: "",
            type: "textarea",
            required: true,
            prepend_content: {
              name: "chat-square-text"
            }
          }
        ]
      }
    },
    methods: {
      async getTrackingClasses() {
        try {
          const response = await dataListClasesSeguimientos(this, "S")
          this.tracking_fields[0].options = [
            {
              value: "",
              label: "Seleccionar"
            },
            ...response.map(item => { 
              return { 
                value: item.id_ClaseSeguimiento, 
                label: item.descripcion
              }
            })
          ]
        } catch (error) {
          console.log(error)
        }
      },
      async saveTracking(e) {
        e.preventDefault();
        e.stopPropagation();

        this.loading = true;

        try {
          let datosSeguimiento = {
            personal: this.employeeId ? this.employeeId : this.$store.state.user.data.id_Empleado,
            estado: "A",
            usuario: this.$store.state.user.data.id_Usuario,
            oportunidad: this.opportunityId
          }

          this.tracking_fields.forEach(field => {
            if (field.value.length > 0) {
              datosSeguimiento[field.key] = field.value;
            }
          });

          console.log(datosSeguimiento);

          await guardarSeguimiento(this, datosSeguimiento);

          this.$store.commit('setAlert', {
            color: "success",
            message: 'Acción exitosa',
            show: 5
          })

          this.showPanelTracking = false
        } catch (error) {
          console.log(error);

          this.$store.commit('setAlert', {
            color: "danger",
            message: `Error: ${error.status} - ${error.statusText}`,
            show: 5
          });
        } finally {
          this.loading = false;

          this.close();
        }
      },
      // async saveAttachment(e) {
      //   e.preventDefault();
      //   e.stopPropagation();

      //   this.loading = true

      //   try {
      //     let fileName = this.attachments_fields[2].value[0].name
      //     let fileBase64 = await this.toBase64(this.attachments_fields[2].value).then(file => file)
      //     let parametros = {
      //       "Id_TipoAnexo": this.attachments_fields[0].value,
      //       "Id_Directorio": this.idDirectory ? this.idDirectory : null,
      //       "Id_Personal": this.idEmployee ? this.idEmployee : null,
      //       "Id_Documento": this.idDocument ? this.idDocument : null,
      //       "Id_Pedido": this.idOrder ? this.idOrder : null,
      //       "Id_ContratoArrendamiento": this.idLeasingContract ? this.idLeasingContract : null,
      //       "Observaciones": this.attachments_fields[1].value ? this.attachments_fields[1].value : null,
      //       "Nombre_Archivo": fileName,
      //       "Archivo_Base64": fileBase64
      //     }
  
      //     const { errorCode, errorMessage, response} = await guardarSeguimiento(this, parametros)
  
      //     if (errorCode === 0) {
      //       this.$store.commit("setAlert", {
      //         color: "success",
      //         message: `Se grabo el archivo ${response.nombre_Documento} exitosamente...`,
      //         show: 5
      //       })
      //     } else {
      //       this.$store.commit("setAlert", {
      //         color: "warning",
      //         message: errorMessage,
      //         show: 5
      //       })
      //     }
      //   } catch (error) {
      //     this.$store.commit("setAlert", {
      //       color: "danger",
      //       message: `Error: ${error.status} - ${error.statusText}`,
      //       show: 5
      //     })
      //   } finally {
      //     this.loading = false;

      //     this.close();
      //   }
      // },
      close() {
        this.$emit("closeWindow")
      }
    },
    computed: {
      isValidForm() {
        return this.tracking_fields.every(field => {
          if (field.required) {
            if (typeof field.value === "string") {
              return field.value.length > 0;
            }
            if (typeof field.value === 'object') {
              return field.value.length > 0;
            }
          }

          return true;
        });
      }
    },
    setup() {
    },
    created() {
      this.getTrackingClasses();
    },
    mounted() {
      this.tracking_fields[0].value = "";
      this.tracking_fields[1].value = moment().format('YYYY-MM-DD');
      this.tracking_fields[2].value = moment().format('HH:mm');
      this.tracking_fields[3].value = "";
    }
  }
</script>
